<div class="px-3 py-3">
  <div class="row justify-content-center">
  <div class="col-xxl-5 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
    <mat-card class="shadow">
      <form [formGroup]="importPricelistForm" (ngSubmit)="onSubmit()">
        <h3 class="content-label-each">{{'pages.placeholders.RetailerPricelistimport' | translate }}</h3>
        <div class="row my-4">
          <div class="form-group">
              <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
              <div class="form-item-input">
              <input type="file"
                     id="file"
                     (change)="handleFileInput($event.target.files)"> 
              </div>
              </div>       
          </div>
        </div>
        <div class="row my-4">
          <div class="col-lg-4 col-md-4 col-sm-4 col-xs-12 align-self-center">
            <h4 class="form-item-label" translate>
              pages.newRetailer.provider<span class="required">*</span>
            </h4>
          </div>
          <div class="col-lg-8 col-md-7 col-sm-8 col-xs-12 align-self-center">
            <div class="form-item-input">
              <mat-form-field appearance="outline" class="w-100">
                  <mat-select formControlName="providerid">
                      <mat-option
                        *ngFor="let provider of providers"
                        [value]="provider.providerId"
                      >
                        {{ provider.providerName }}
                      </mat-option>
                    </mat-select>
              </mat-form-field>
              
            </div>
          </div>
        </div>
        <div class="form-footer mt-6">
          <ul class="list-inline text-center">
            <li class="list-inline-item">
              <button
                mat-raised-button
                [disabled]="!importPricelistForm.valid || !fileuploaded"
                color="primary"
                type="submit"
                class="rounded-0"
              > 
                <span translate class="translate">Submit</span>
              </button>
            </li>
            <li class="list-inline-item">
              <button
               mat-stroked-button
                color="primary"
                type="button"
                class="rounded-0"
                (click)="onCancel()"
              >
                <span translate class="translate">pages.newRetailer.cancel</span>
              </button>
            </li>
          </ul>
        </div>
      </form>
    </mat-card>
  </div>
</div>
</div>